import { SENSITIVE_STRING } from "@smithy/smithy-client";
import { VerifiedPermissionsServiceException as __BaseException } from "./VerifiedPermissionsServiceException";
export class AccessDeniedException extends __BaseException {
    name = "AccessDeniedException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, AccessDeniedException.prototype);
    }
}
export const BatchGetPolicyErrorCode = {
    POLICY_NOT_FOUND: "POLICY_NOT_FOUND",
    POLICY_STORE_NOT_FOUND: "POLICY_STORE_NOT_FOUND",
};
export var PolicyDefinitionDetail;
(function (PolicyDefinitionDetail) {
    PolicyDefinitionDetail.visit = (value, visitor) => {
        if (value.static !== undefined)
            return visitor.static(value.static);
        if (value.templateLinked !== undefined)
            return visitor.templateLinked(value.templateLinked);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(PolicyDefinitionDetail || (PolicyDefinitionDetail = {}));
export const PolicyType = {
    STATIC: "STATIC",
    TEMPLATE_LINKED: "TEMPLATE_LINKED",
};
export class InternalServerException extends __BaseException {
    name = "InternalServerException";
    $fault = "server";
    $retryable = {};
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalServerException.prototype);
    }
}
export class ThrottlingException extends __BaseException {
    name = "ThrottlingException";
    $fault = "client";
    $retryable = {
        throttling: true,
    };
    serviceCode;
    quotaCode;
    constructor(opts) {
        super({
            name: "ThrottlingException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ThrottlingException.prototype);
        this.serviceCode = opts.serviceCode;
        this.quotaCode = opts.quotaCode;
    }
}
export class ValidationException extends __BaseException {
    name = "ValidationException";
    $fault = "client";
    fieldList;
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.fieldList = opts.fieldList;
    }
}
export const Decision = {
    ALLOW: "ALLOW",
    DENY: "DENY",
};
export const ResourceType = {
    IDENTITY_SOURCE: "IDENTITY_SOURCE",
    POLICY: "POLICY",
    POLICY_STORE: "POLICY_STORE",
    POLICY_TEMPLATE: "POLICY_TEMPLATE",
    SCHEMA: "SCHEMA",
};
export class ResourceNotFoundException extends __BaseException {
    name = "ResourceNotFoundException";
    $fault = "client";
    resourceId;
    resourceType;
    constructor(opts) {
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ResourceNotFoundException.prototype);
        this.resourceId = opts.resourceId;
        this.resourceType = opts.resourceType;
    }
}
export const CedarVersion = {
    CEDAR_2: "CEDAR_2",
    CEDAR_4: "CEDAR_4",
};
export var OpenIdConnectTokenSelection;
(function (OpenIdConnectTokenSelection) {
    OpenIdConnectTokenSelection.visit = (value, visitor) => {
        if (value.accessTokenOnly !== undefined)
            return visitor.accessTokenOnly(value.accessTokenOnly);
        if (value.identityTokenOnly !== undefined)
            return visitor.identityTokenOnly(value.identityTokenOnly);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(OpenIdConnectTokenSelection || (OpenIdConnectTokenSelection = {}));
export var Configuration;
(function (Configuration) {
    Configuration.visit = (value, visitor) => {
        if (value.cognitoUserPoolConfiguration !== undefined)
            return visitor.cognitoUserPoolConfiguration(value.cognitoUserPoolConfiguration);
        if (value.openIdConnectConfiguration !== undefined)
            return visitor.openIdConnectConfiguration(value.openIdConnectConfiguration);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(Configuration || (Configuration = {}));
export var OpenIdConnectTokenSelectionDetail;
(function (OpenIdConnectTokenSelectionDetail) {
    OpenIdConnectTokenSelectionDetail.visit = (value, visitor) => {
        if (value.accessTokenOnly !== undefined)
            return visitor.accessTokenOnly(value.accessTokenOnly);
        if (value.identityTokenOnly !== undefined)
            return visitor.identityTokenOnly(value.identityTokenOnly);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(OpenIdConnectTokenSelectionDetail || (OpenIdConnectTokenSelectionDetail = {}));
export var ConfigurationDetail;
(function (ConfigurationDetail) {
    ConfigurationDetail.visit = (value, visitor) => {
        if (value.cognitoUserPoolConfiguration !== undefined)
            return visitor.cognitoUserPoolConfiguration(value.cognitoUserPoolConfiguration);
        if (value.openIdConnectConfiguration !== undefined)
            return visitor.openIdConnectConfiguration(value.openIdConnectConfiguration);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(ConfigurationDetail || (ConfigurationDetail = {}));
export var OpenIdConnectTokenSelectionItem;
(function (OpenIdConnectTokenSelectionItem) {
    OpenIdConnectTokenSelectionItem.visit = (value, visitor) => {
        if (value.accessTokenOnly !== undefined)
            return visitor.accessTokenOnly(value.accessTokenOnly);
        if (value.identityTokenOnly !== undefined)
            return visitor.identityTokenOnly(value.identityTokenOnly);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(OpenIdConnectTokenSelectionItem || (OpenIdConnectTokenSelectionItem = {}));
export var ConfigurationItem;
(function (ConfigurationItem) {
    ConfigurationItem.visit = (value, visitor) => {
        if (value.cognitoUserPoolConfiguration !== undefined)
            return visitor.cognitoUserPoolConfiguration(value.cognitoUserPoolConfiguration);
        if (value.openIdConnectConfiguration !== undefined)
            return visitor.openIdConnectConfiguration(value.openIdConnectConfiguration);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(ConfigurationItem || (ConfigurationItem = {}));
export class ConflictException extends __BaseException {
    name = "ConflictException";
    $fault = "client";
    resources;
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ConflictException.prototype);
        this.resources = opts.resources;
    }
}
export class ServiceQuotaExceededException extends __BaseException {
    name = "ServiceQuotaExceededException";
    $fault = "client";
    resourceId;
    resourceType;
    serviceCode;
    quotaCode;
    constructor(opts) {
        super({
            name: "ServiceQuotaExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ServiceQuotaExceededException.prototype);
        this.resourceId = opts.resourceId;
        this.resourceType = opts.resourceType;
        this.serviceCode = opts.serviceCode;
        this.quotaCode = opts.quotaCode;
    }
}
export var PolicyDefinition;
(function (PolicyDefinition) {
    PolicyDefinition.visit = (value, visitor) => {
        if (value.static !== undefined)
            return visitor.static(value.static);
        if (value.templateLinked !== undefined)
            return visitor.templateLinked(value.templateLinked);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(PolicyDefinition || (PolicyDefinition = {}));
export const PolicyEffect = {
    FORBID: "Forbid",
    PERMIT: "Permit",
};
export const DeletionProtection = {
    DISABLED: "DISABLED",
    ENABLED: "ENABLED",
};
export const ValidationMode = {
    OFF: "OFF",
    STRICT: "STRICT",
};
export class InvalidStateException extends __BaseException {
    name = "InvalidStateException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidStateException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidStateException.prototype);
    }
}
export var EntityReference;
(function (EntityReference) {
    EntityReference.visit = (value, visitor) => {
        if (value.unspecified !== undefined)
            return visitor.unspecified(value.unspecified);
        if (value.identifier !== undefined)
            return visitor.identifier(value.identifier);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(EntityReference || (EntityReference = {}));
export const OpenIdIssuer = {
    COGNITO: "COGNITO",
};
export var UpdateOpenIdConnectTokenSelection;
(function (UpdateOpenIdConnectTokenSelection) {
    UpdateOpenIdConnectTokenSelection.visit = (value, visitor) => {
        if (value.accessTokenOnly !== undefined)
            return visitor.accessTokenOnly(value.accessTokenOnly);
        if (value.identityTokenOnly !== undefined)
            return visitor.identityTokenOnly(value.identityTokenOnly);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(UpdateOpenIdConnectTokenSelection || (UpdateOpenIdConnectTokenSelection = {}));
export var UpdateConfiguration;
(function (UpdateConfiguration) {
    UpdateConfiguration.visit = (value, visitor) => {
        if (value.cognitoUserPoolConfiguration !== undefined)
            return visitor.cognitoUserPoolConfiguration(value.cognitoUserPoolConfiguration);
        if (value.openIdConnectConfiguration !== undefined)
            return visitor.openIdConnectConfiguration(value.openIdConnectConfiguration);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(UpdateConfiguration || (UpdateConfiguration = {}));
export var PolicyDefinitionItem;
(function (PolicyDefinitionItem) {
    PolicyDefinitionItem.visit = (value, visitor) => {
        if (value.static !== undefined)
            return visitor.static(value.static);
        if (value.templateLinked !== undefined)
            return visitor.templateLinked(value.templateLinked);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(PolicyDefinitionItem || (PolicyDefinitionItem = {}));
export var UpdatePolicyDefinition;
(function (UpdatePolicyDefinition) {
    UpdatePolicyDefinition.visit = (value, visitor) => {
        if (value.static !== undefined)
            return visitor.static(value.static);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(UpdatePolicyDefinition || (UpdatePolicyDefinition = {}));
export var SchemaDefinition;
(function (SchemaDefinition) {
    SchemaDefinition.visit = (value, visitor) => {
        if (value.cedarJson !== undefined)
            return visitor.cedarJson(value.cedarJson);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(SchemaDefinition || (SchemaDefinition = {}));
export class TooManyTagsException extends __BaseException {
    name = "TooManyTagsException";
    $fault = "client";
    resourceName;
    constructor(opts) {
        super({
            name: "TooManyTagsException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TooManyTagsException.prototype);
        this.resourceName = opts.resourceName;
    }
}
export var AttributeValue;
(function (AttributeValue) {
    AttributeValue.visit = (value, visitor) => {
        if (value.boolean !== undefined)
            return visitor.boolean(value.boolean);
        if (value.entityIdentifier !== undefined)
            return visitor.entityIdentifier(value.entityIdentifier);
        if (value.long !== undefined)
            return visitor.long(value.long);
        if (value.string !== undefined)
            return visitor.string(value.string);
        if (value.set !== undefined)
            return visitor.set(value.set);
        if (value.record !== undefined)
            return visitor.record(value.record);
        if (value.ipaddr !== undefined)
            return visitor.ipaddr(value.ipaddr);
        if (value.decimal !== undefined)
            return visitor.decimal(value.decimal);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AttributeValue || (AttributeValue = {}));
export var ContextDefinition;
(function (ContextDefinition) {
    ContextDefinition.visit = (value, visitor) => {
        if (value.contextMap !== undefined)
            return visitor.contextMap(value.contextMap);
        if (value.cedarJson !== undefined)
            return visitor.cedarJson(value.cedarJson);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(ContextDefinition || (ContextDefinition = {}));
export var EntitiesDefinition;
(function (EntitiesDefinition) {
    EntitiesDefinition.visit = (value, visitor) => {
        if (value.entityList !== undefined)
            return visitor.entityList(value.entityList);
        if (value.cedarJson !== undefined)
            return visitor.cedarJson(value.cedarJson);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(EntitiesDefinition || (EntitiesDefinition = {}));
export const ActionIdentifierFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.actionType && { actionType: SENSITIVE_STRING }),
    ...(obj.actionId && { actionId: SENSITIVE_STRING }),
});
export const EntityIdentifierFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.entityType && { entityType: SENSITIVE_STRING }),
    ...(obj.entityId && { entityId: SENSITIVE_STRING }),
});
export const StaticPolicyDefinitionDetailFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
    ...(obj.statement && { statement: SENSITIVE_STRING }),
});
export const TemplateLinkedPolicyDefinitionDetailFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
});
export const PolicyDefinitionDetailFilterSensitiveLog = (obj) => {
    if (obj.static !== undefined)
        return { static: StaticPolicyDefinitionDetailFilterSensitiveLog(obj.static) };
    if (obj.templateLinked !== undefined)
        return { templateLinked: TemplateLinkedPolicyDefinitionDetailFilterSensitiveLog(obj.templateLinked) };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const BatchGetPolicyOutputItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.definition && { definition: PolicyDefinitionDetailFilterSensitiveLog(obj.definition) }),
});
export const BatchGetPolicyOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.results && { results: obj.results.map((item) => BatchGetPolicyOutputItemFilterSensitiveLog(item)) }),
});
export const EvaluationErrorItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CognitoGroupConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.groupEntityType && { groupEntityType: SENSITIVE_STRING }),
});
export const CognitoGroupConfigurationDetailFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.groupEntityType && { groupEntityType: SENSITIVE_STRING }),
});
export const CognitoGroupConfigurationItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.groupEntityType && { groupEntityType: SENSITIVE_STRING }),
});
export const CognitoUserPoolConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
    ...(obj.groupConfiguration && {
        groupConfiguration: CognitoGroupConfigurationFilterSensitiveLog(obj.groupConfiguration),
    }),
});
export const CognitoUserPoolConfigurationDetailFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
    ...(obj.groupConfiguration && {
        groupConfiguration: CognitoGroupConfigurationDetailFilterSensitiveLog(obj.groupConfiguration),
    }),
});
export const CognitoUserPoolConfigurationItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
    ...(obj.groupConfiguration && {
        groupConfiguration: CognitoGroupConfigurationItemFilterSensitiveLog(obj.groupConfiguration),
    }),
});
export const OpenIdConnectGroupConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.groupClaim && { groupClaim: SENSITIVE_STRING }),
    ...(obj.groupEntityType && { groupEntityType: SENSITIVE_STRING }),
});
export const OpenIdConnectAccessTokenConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principalIdClaim && { principalIdClaim: SENSITIVE_STRING }),
});
export const OpenIdConnectIdentityTokenConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principalIdClaim && { principalIdClaim: SENSITIVE_STRING }),
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
});
export const OpenIdConnectTokenSelectionFilterSensitiveLog = (obj) => {
    if (obj.accessTokenOnly !== undefined)
        return { accessTokenOnly: OpenIdConnectAccessTokenConfigurationFilterSensitiveLog(obj.accessTokenOnly) };
    if (obj.identityTokenOnly !== undefined)
        return { identityTokenOnly: OpenIdConnectIdentityTokenConfigurationFilterSensitiveLog(obj.identityTokenOnly) };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const OpenIdConnectConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.entityIdPrefix && { entityIdPrefix: SENSITIVE_STRING }),
    ...(obj.groupConfiguration && {
        groupConfiguration: OpenIdConnectGroupConfigurationFilterSensitiveLog(obj.groupConfiguration),
    }),
    ...(obj.tokenSelection && { tokenSelection: OpenIdConnectTokenSelectionFilterSensitiveLog(obj.tokenSelection) }),
});
export const ConfigurationFilterSensitiveLog = (obj) => {
    if (obj.cognitoUserPoolConfiguration !== undefined)
        return {
            cognitoUserPoolConfiguration: CognitoUserPoolConfigurationFilterSensitiveLog(obj.cognitoUserPoolConfiguration),
        };
    if (obj.openIdConnectConfiguration !== undefined)
        return { openIdConnectConfiguration: OpenIdConnectConfigurationFilterSensitiveLog(obj.openIdConnectConfiguration) };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const OpenIdConnectGroupConfigurationDetailFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.groupClaim && { groupClaim: SENSITIVE_STRING }),
    ...(obj.groupEntityType && { groupEntityType: SENSITIVE_STRING }),
});
export const OpenIdConnectAccessTokenConfigurationDetailFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principalIdClaim && { principalIdClaim: SENSITIVE_STRING }),
});
export const OpenIdConnectIdentityTokenConfigurationDetailFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principalIdClaim && { principalIdClaim: SENSITIVE_STRING }),
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
});
export const OpenIdConnectTokenSelectionDetailFilterSensitiveLog = (obj) => {
    if (obj.accessTokenOnly !== undefined)
        return { accessTokenOnly: OpenIdConnectAccessTokenConfigurationDetailFilterSensitiveLog(obj.accessTokenOnly) };
    if (obj.identityTokenOnly !== undefined)
        return {
            identityTokenOnly: OpenIdConnectIdentityTokenConfigurationDetailFilterSensitiveLog(obj.identityTokenOnly),
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const OpenIdConnectConfigurationDetailFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.entityIdPrefix && { entityIdPrefix: SENSITIVE_STRING }),
    ...(obj.groupConfiguration && {
        groupConfiguration: OpenIdConnectGroupConfigurationDetailFilterSensitiveLog(obj.groupConfiguration),
    }),
    ...(obj.tokenSelection && {
        tokenSelection: OpenIdConnectTokenSelectionDetailFilterSensitiveLog(obj.tokenSelection),
    }),
});
export const ConfigurationDetailFilterSensitiveLog = (obj) => {
    if (obj.cognitoUserPoolConfiguration !== undefined)
        return {
            cognitoUserPoolConfiguration: CognitoUserPoolConfigurationDetailFilterSensitiveLog(obj.cognitoUserPoolConfiguration),
        };
    if (obj.openIdConnectConfiguration !== undefined)
        return {
            openIdConnectConfiguration: OpenIdConnectConfigurationDetailFilterSensitiveLog(obj.openIdConnectConfiguration),
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const OpenIdConnectGroupConfigurationItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.groupClaim && { groupClaim: SENSITIVE_STRING }),
    ...(obj.groupEntityType && { groupEntityType: SENSITIVE_STRING }),
});
export const OpenIdConnectAccessTokenConfigurationItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principalIdClaim && { principalIdClaim: SENSITIVE_STRING }),
});
export const OpenIdConnectIdentityTokenConfigurationItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principalIdClaim && { principalIdClaim: SENSITIVE_STRING }),
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
});
export const OpenIdConnectTokenSelectionItemFilterSensitiveLog = (obj) => {
    if (obj.accessTokenOnly !== undefined)
        return { accessTokenOnly: OpenIdConnectAccessTokenConfigurationItemFilterSensitiveLog(obj.accessTokenOnly) };
    if (obj.identityTokenOnly !== undefined)
        return { identityTokenOnly: OpenIdConnectIdentityTokenConfigurationItemFilterSensitiveLog(obj.identityTokenOnly) };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const OpenIdConnectConfigurationItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.entityIdPrefix && { entityIdPrefix: SENSITIVE_STRING }),
    ...(obj.groupConfiguration && {
        groupConfiguration: OpenIdConnectGroupConfigurationItemFilterSensitiveLog(obj.groupConfiguration),
    }),
    ...(obj.tokenSelection && { tokenSelection: OpenIdConnectTokenSelectionItemFilterSensitiveLog(obj.tokenSelection) }),
});
export const ConfigurationItemFilterSensitiveLog = (obj) => {
    if (obj.cognitoUserPoolConfiguration !== undefined)
        return {
            cognitoUserPoolConfiguration: CognitoUserPoolConfigurationItemFilterSensitiveLog(obj.cognitoUserPoolConfiguration),
        };
    if (obj.openIdConnectConfiguration !== undefined)
        return {
            openIdConnectConfiguration: OpenIdConnectConfigurationItemFilterSensitiveLog(obj.openIdConnectConfiguration),
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const CreateIdentitySourceInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.configuration && { configuration: ConfigurationFilterSensitiveLog(obj.configuration) }),
    ...(obj.principalEntityType && { principalEntityType: SENSITIVE_STRING }),
});
export const StaticPolicyDefinitionFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
    ...(obj.statement && { statement: SENSITIVE_STRING }),
});
export const TemplateLinkedPolicyDefinitionFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
});
export const PolicyDefinitionFilterSensitiveLog = (obj) => {
    if (obj.static !== undefined)
        return { static: StaticPolicyDefinitionFilterSensitiveLog(obj.static) };
    if (obj.templateLinked !== undefined)
        return { templateLinked: TemplateLinkedPolicyDefinitionFilterSensitiveLog(obj.templateLinked) };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const CreatePolicyInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.definition && { definition: PolicyDefinitionFilterSensitiveLog(obj.definition) }),
});
export const CreatePolicyOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
    ...(obj.actions && { actions: obj.actions.map((item) => ActionIdentifierFilterSensitiveLog(item)) }),
});
export const CreatePolicyStoreInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
});
export const CreatePolicyTemplateInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
    ...(obj.statement && { statement: SENSITIVE_STRING }),
});
export const EntityReferenceFilterSensitiveLog = (obj) => {
    if (obj.unspecified !== undefined)
        return { unspecified: obj.unspecified };
    if (obj.identifier !== undefined)
        return { identifier: EntityIdentifierFilterSensitiveLog(obj.identifier) };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const IdentitySourceDetailsFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
});
export const GetIdentitySourceOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.details && { details: IdentitySourceDetailsFilterSensitiveLog(obj.details) }),
    ...(obj.principalEntityType && { principalEntityType: SENSITIVE_STRING }),
    ...(obj.configuration && { configuration: ConfigurationDetailFilterSensitiveLog(obj.configuration) }),
});
export const GetPolicyOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
    ...(obj.actions && { actions: obj.actions.map((item) => ActionIdentifierFilterSensitiveLog(item)) }),
    ...(obj.definition && { definition: PolicyDefinitionDetailFilterSensitiveLog(obj.definition) }),
});
export const GetPolicyStoreOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
});
export const GetPolicyTemplateOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
    ...(obj.statement && { statement: SENSITIVE_STRING }),
});
export const GetSchemaOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.schema && { schema: SENSITIVE_STRING }),
    ...(obj.namespaces && { namespaces: SENSITIVE_STRING }),
});
export const IdentitySourceFilterFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principalEntityType && { principalEntityType: SENSITIVE_STRING }),
});
export const ListIdentitySourcesInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.filters && { filters: obj.filters.map((item) => IdentitySourceFilterFilterSensitiveLog(item)) }),
});
export const IdentitySourceItemDetailsFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
});
export const IdentitySourceItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.details && { details: IdentitySourceItemDetailsFilterSensitiveLog(obj.details) }),
    ...(obj.principalEntityType && { principalEntityType: SENSITIVE_STRING }),
    ...(obj.configuration && { configuration: ConfigurationItemFilterSensitiveLog(obj.configuration) }),
});
export const ListIdentitySourcesOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.identitySources && {
        identitySources: obj.identitySources.map((item) => IdentitySourceItemFilterSensitiveLog(item)),
    }),
});
export const UpdateCognitoGroupConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.groupEntityType && { groupEntityType: SENSITIVE_STRING }),
});
export const UpdateCognitoUserPoolConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
    ...(obj.groupConfiguration && {
        groupConfiguration: UpdateCognitoGroupConfigurationFilterSensitiveLog(obj.groupConfiguration),
    }),
});
export const UpdateOpenIdConnectGroupConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.groupClaim && { groupClaim: SENSITIVE_STRING }),
    ...(obj.groupEntityType && { groupEntityType: SENSITIVE_STRING }),
});
export const UpdateOpenIdConnectAccessTokenConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principalIdClaim && { principalIdClaim: SENSITIVE_STRING }),
});
export const UpdateOpenIdConnectIdentityTokenConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principalIdClaim && { principalIdClaim: SENSITIVE_STRING }),
    ...(obj.clientIds && { clientIds: SENSITIVE_STRING }),
});
export const UpdateOpenIdConnectTokenSelectionFilterSensitiveLog = (obj) => {
    if (obj.accessTokenOnly !== undefined)
        return { accessTokenOnly: UpdateOpenIdConnectAccessTokenConfigurationFilterSensitiveLog(obj.accessTokenOnly) };
    if (obj.identityTokenOnly !== undefined)
        return {
            identityTokenOnly: UpdateOpenIdConnectIdentityTokenConfigurationFilterSensitiveLog(obj.identityTokenOnly),
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const UpdateOpenIdConnectConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.entityIdPrefix && { entityIdPrefix: SENSITIVE_STRING }),
    ...(obj.groupConfiguration && {
        groupConfiguration: UpdateOpenIdConnectGroupConfigurationFilterSensitiveLog(obj.groupConfiguration),
    }),
    ...(obj.tokenSelection && {
        tokenSelection: UpdateOpenIdConnectTokenSelectionFilterSensitiveLog(obj.tokenSelection),
    }),
});
export const UpdateConfigurationFilterSensitiveLog = (obj) => {
    if (obj.cognitoUserPoolConfiguration !== undefined)
        return {
            cognitoUserPoolConfiguration: UpdateCognitoUserPoolConfigurationFilterSensitiveLog(obj.cognitoUserPoolConfiguration),
        };
    if (obj.openIdConnectConfiguration !== undefined)
        return {
            openIdConnectConfiguration: UpdateOpenIdConnectConfigurationFilterSensitiveLog(obj.openIdConnectConfiguration),
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const UpdateIdentitySourceInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.updateConfiguration && {
        updateConfiguration: UpdateConfigurationFilterSensitiveLog(obj.updateConfiguration),
    }),
    ...(obj.principalEntityType && { principalEntityType: SENSITIVE_STRING }),
});
export const IsAuthorizedOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.errors && { errors: SENSITIVE_STRING }),
});
export const IsAuthorizedWithTokenOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.errors && { errors: SENSITIVE_STRING }),
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
});
export const PolicyFilterFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityReferenceFilterSensitiveLog(obj.principal) }),
    ...(obj.resource && { resource: EntityReferenceFilterSensitiveLog(obj.resource) }),
});
export const ListPoliciesInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.filter && { filter: PolicyFilterFilterSensitiveLog(obj.filter) }),
});
export const StaticPolicyDefinitionItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
});
export const TemplateLinkedPolicyDefinitionItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
});
export const PolicyDefinitionItemFilterSensitiveLog = (obj) => {
    if (obj.static !== undefined)
        return { static: StaticPolicyDefinitionItemFilterSensitiveLog(obj.static) };
    if (obj.templateLinked !== undefined)
        return { templateLinked: TemplateLinkedPolicyDefinitionItemFilterSensitiveLog(obj.templateLinked) };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const PolicyItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
    ...(obj.actions && { actions: obj.actions.map((item) => ActionIdentifierFilterSensitiveLog(item)) }),
    ...(obj.definition && { definition: PolicyDefinitionItemFilterSensitiveLog(obj.definition) }),
});
export const ListPoliciesOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.policies && { policies: obj.policies.map((item) => PolicyItemFilterSensitiveLog(item)) }),
});
export const PolicyStoreItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
});
export const ListPolicyStoresOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.policyStores && { policyStores: obj.policyStores.map((item) => PolicyStoreItemFilterSensitiveLog(item)) }),
});
export const PolicyTemplateItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
});
export const ListPolicyTemplatesOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.policyTemplates && {
        policyTemplates: obj.policyTemplates.map((item) => PolicyTemplateItemFilterSensitiveLog(item)),
    }),
});
export const UpdateStaticPolicyDefinitionFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
    ...(obj.statement && { statement: SENSITIVE_STRING }),
});
export const UpdatePolicyDefinitionFilterSensitiveLog = (obj) => {
    if (obj.static !== undefined)
        return { static: UpdateStaticPolicyDefinitionFilterSensitiveLog(obj.static) };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const UpdatePolicyInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.definition && { definition: UpdatePolicyDefinitionFilterSensitiveLog(obj.definition) }),
});
export const UpdatePolicyOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
    ...(obj.actions && { actions: obj.actions.map((item) => ActionIdentifierFilterSensitiveLog(item)) }),
});
export const UpdatePolicyTemplateInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
    ...(obj.statement && { statement: SENSITIVE_STRING }),
});
export const SchemaDefinitionFilterSensitiveLog = (obj) => {
    if (obj.cedarJson !== undefined)
        return { cedarJson: SENSITIVE_STRING };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const PutSchemaInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.definition && { definition: SchemaDefinitionFilterSensitiveLog(obj.definition) }),
});
export const PutSchemaOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.namespaces && { namespaces: SENSITIVE_STRING }),
});
export const UpdatePolicyStoreInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.description && { description: SENSITIVE_STRING }),
});
export const AttributeValueFilterSensitiveLog = (obj) => {
    if (obj.boolean !== undefined)
        return { boolean: SENSITIVE_STRING };
    if (obj.entityIdentifier !== undefined)
        return { entityIdentifier: EntityIdentifierFilterSensitiveLog(obj.entityIdentifier) };
    if (obj.long !== undefined)
        return { long: SENSITIVE_STRING };
    if (obj.string !== undefined)
        return { string: SENSITIVE_STRING };
    if (obj.set !== undefined)
        return { set: obj.set.map((item) => AttributeValueFilterSensitiveLog(item)) };
    if (obj.record !== undefined)
        return {
            record: Object.entries(obj.record).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
        };
    if (obj.ipaddr !== undefined)
        return { ipaddr: SENSITIVE_STRING };
    if (obj.decimal !== undefined)
        return { decimal: SENSITIVE_STRING };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const ContextDefinitionFilterSensitiveLog = (obj) => {
    if (obj.contextMap !== undefined)
        return { contextMap: SENSITIVE_STRING };
    if (obj.cedarJson !== undefined)
        return { cedarJson: SENSITIVE_STRING };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const EntityItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.identifier && { identifier: EntityIdentifierFilterSensitiveLog(obj.identifier) }),
    ...(obj.attributes && {
        attributes: Object.entries(obj.attributes).reduce((acc, [key, value]) => ((acc[key] = AttributeValueFilterSensitiveLog(value)), acc), {}),
    }),
    ...(obj.parents && { parents: obj.parents.map((item) => EntityIdentifierFilterSensitiveLog(item)) }),
});
export const BatchIsAuthorizedInputItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.action && { action: ActionIdentifierFilterSensitiveLog(obj.action) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
    ...(obj.context && { context: ContextDefinitionFilterSensitiveLog(obj.context) }),
});
export const BatchIsAuthorizedWithTokenInputItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.action && { action: ActionIdentifierFilterSensitiveLog(obj.action) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
    ...(obj.context && { context: ContextDefinitionFilterSensitiveLog(obj.context) }),
});
export const BatchIsAuthorizedOutputItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.request && { request: BatchIsAuthorizedInputItemFilterSensitiveLog(obj.request) }),
    ...(obj.errors && { errors: SENSITIVE_STRING }),
});
export const BatchIsAuthorizedWithTokenOutputItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.request && { request: BatchIsAuthorizedWithTokenInputItemFilterSensitiveLog(obj.request) }),
    ...(obj.errors && { errors: SENSITIVE_STRING }),
});
export const EntitiesDefinitionFilterSensitiveLog = (obj) => {
    if (obj.entityList !== undefined)
        return { entityList: obj.entityList.map((item) => EntityItemFilterSensitiveLog(item)) };
    if (obj.cedarJson !== undefined)
        return { cedarJson: SENSITIVE_STRING };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const BatchIsAuthorizedOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.results && { results: obj.results.map((item) => BatchIsAuthorizedOutputItemFilterSensitiveLog(item)) }),
});
export const BatchIsAuthorizedWithTokenOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.results && {
        results: obj.results.map((item) => BatchIsAuthorizedWithTokenOutputItemFilterSensitiveLog(item)),
    }),
});
export const IsAuthorizedInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.principal && { principal: EntityIdentifierFilterSensitiveLog(obj.principal) }),
    ...(obj.action && { action: ActionIdentifierFilterSensitiveLog(obj.action) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
    ...(obj.context && { context: ContextDefinitionFilterSensitiveLog(obj.context) }),
    ...(obj.entities && { entities: EntitiesDefinitionFilterSensitiveLog(obj.entities) }),
});
export const IsAuthorizedWithTokenInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.identityToken && { identityToken: SENSITIVE_STRING }),
    ...(obj.accessToken && { accessToken: SENSITIVE_STRING }),
    ...(obj.action && { action: ActionIdentifierFilterSensitiveLog(obj.action) }),
    ...(obj.resource && { resource: EntityIdentifierFilterSensitiveLog(obj.resource) }),
    ...(obj.context && { context: ContextDefinitionFilterSensitiveLog(obj.context) }),
    ...(obj.entities && { entities: EntitiesDefinitionFilterSensitiveLog(obj.entities) }),
});
export const BatchIsAuthorizedInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.entities && { entities: EntitiesDefinitionFilterSensitiveLog(obj.entities) }),
    ...(obj.requests && { requests: obj.requests.map((item) => BatchIsAuthorizedInputItemFilterSensitiveLog(item)) }),
});
export const BatchIsAuthorizedWithTokenInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.identityToken && { identityToken: SENSITIVE_STRING }),
    ...(obj.accessToken && { accessToken: SENSITIVE_STRING }),
    ...(obj.entities && { entities: EntitiesDefinitionFilterSensitiveLog(obj.entities) }),
    ...(obj.requests && {
        requests: obj.requests.map((item) => BatchIsAuthorizedWithTokenInputItemFilterSensitiveLog(item)),
    }),
});
